import { PublicPreReserveUrl } from './urls'
import showResponseError from '../../../../utils/showResponseError'
/* eslint-disable camelcase */
import {
  createSlice,
  PayloadAction,
  createAsyncThunk,
  ActionReducerMapBuilder,
} from '@reduxjs/toolkit'

import { AppHttpConfig as API } from '../../../../services/httpConfig'

import toastify from '../../../../utils/toastify'
import { ToastType } from '../../../../types/generalType'
import { t } from 'i18next'
import { IReserveNewPreReserveInitialState, TCreatePreReserve, TPilgrim } from './types'
import { setAuthForm } from '../../auth/authSlice'
import { AuthForm } from '../../auth/type'

const initialState: IReserveNewPreReserveInitialState = {
  preRserve: {
    province: '',
    city: '',
    zone: '',
    phoneNumber: '',
    mobilenumber: '',
    transportationType: 0,
    pilgrims: [],
  },
  createPreReserve: {
    loading: false,
  },
}

// Create PreReserve
export const createPreReservePublic = createAsyncThunk<number, { data: TCreatePreReserve }>(
  'publicPreReserve/createPreReservePublic',
  async (command, thunkAPI) => {
    const { data } = command
    try {
      const response = await API.post(PublicPreReserveUrl.CreatePreReserve, data)
        .then((res) => {
          if (res.status === 201) {
            toastify(ToastType.SUCCESS, { operatin: t('save'), pageName: t('preReserve') })
            thunkAPI.dispatch(clearStates())
            thunkAPI.dispatch(setAuthForm(AuthForm.LOGIN))
            return res.data
          }
          if (res.status === 204) {
            return res.data
          }
        })
        .catch((error) => {
          showResponseError(error)
          return thunkAPI.rejectWithValue(error[0])
        })
      return response
    } catch (error) {
      showResponseError(error)
    }
  },
)

const publicPreReserveSlice = createSlice({
  name: 'publicPreReserve',
  initialState,
  reducers: {
    clearStates: (state) => {
      state.preRserve.city = ''
      state.preRserve.province = ''
      state.preRserve.zone = ''
      state.preRserve.phoneNumber = ''
      state.preRserve.mobilenumber = ''
      state.preRserve.transportationType = 0
      state.preRserve.pilgrims = []
    },

    setReservePilgrimList: (state, action: PayloadAction<TPilgrim[]>) => {
      state.preRserve.pilgrims = action.payload
    },
    setCity: (state, action: PayloadAction<string>) => {
      state.preRserve.city = action.payload
    },
    setProvince: (state, action: PayloadAction<string>) => {
      state.preRserve.province = action.payload
    },
    setZone: (state, action: PayloadAction<string>) => {
      state.preRserve.zone = action.payload
    },
    setTransportationType: (state, action: PayloadAction<number | string>) => {
      state.preRserve.transportationType = action.payload
    },
    setPhoneNumber: (state, action: PayloadAction<string>) => {
      state.preRserve.phoneNumber = action.payload
    },
    setMobileNumber: (state, action: PayloadAction<string>) => {
      state.preRserve.mobilenumber = action.payload
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<IReserveNewPreReserveInitialState>) => {
    // Create PreReserve
    builder
      .addCase(createPreReservePublic.pending, (state) => {
        state.createPreReserve.loading = true
      })
      .addCase(createPreReservePublic.fulfilled, (state) => {
        state.createPreReserve.loading = false
      })
      .addCase(createPreReservePublic.rejected, (state) => {
        state.createPreReserve.loading = false
      })
  },
})

export const {
  clearStates,
  setReservePilgrimList,
  setCity,
  setProvince,
  setZone,
  setTransportationType,
  setPhoneNumber,
  setMobileNumber,
} = publicPreReserveSlice.actions

export default publicPreReserveSlice.reducer
